'use strict';

wbApp.controller('SemestrSchedulerCtrl', ['$scope', '$modal', 'tenantSettingSvc', 'securitySvc', 'currentUser', 'classroomSvc', 'clientSchedulerSvc',
    function ($scope, $modal, tenantSettingSvc, securitySvc, currentUser, classroomSvc, clientSchedulerSvc) {


        // TODO: preselect today if in the middle of semester or fisrt day of semester if outside

        $scope.showClearButton = securitySvc.isInRole('ClientAttendanceAdmin') || tenantSettingSvc.settings.showAllCoursesInClientSchedule;
        var thisTabIndex = $scope.$index;
        var currentSemester = null;
        var currentStudent = null;

        $scope.semesterID = 0;
        $scope.studentCompGrpID = null;
        $scope.isBusy = false;
        

        var lastStartDate = tenantSettingSvc.settings.clientScheduleWeekView
                                ? moment().startOf('isoWeek').toDate()
                                : moment().startOf('day').toDate();
        var lastEndDate = tenantSettingSvc.settings.clientScheduleWeekView
                                ? moment(lastStartDate).add(7, 'day').startOf('day').toDate()
                                : moment(lastStartDate).add(1, 'day').startOf('day').toDate();

        var resources = classroomSvc.getAllActiveAsync( /* classroomIDtoInclude */ null, /* filterForReservations */ false, /* filterForCourses */ true);
        var schedules = [];

        $scope.schedulerSettings = {
            weekView: tenantSettingSvc.settings.clientScheduleWeekView,
            autoHourRange: tenantSettingSvc.settings.scheduleEnableAutoHourRange,
            visibleResources: tenantSettingSvc.settings.scheduleDayViewResourcesPerPage,
           // selectedResourceID: 1,
            startHour: tenantSettingSvc.settings.scheduleVisibleTimeStart,
            endHour: tenantSettingSvc.settings.scheduleVisibleTimeEnd,
            scale: tenantSettingSvc.settings.scheduleTimeScale,
            startDate: lastStartDate,
            resources: resources,
            resourcesMapping: { resourceID: 'id' },
            actions: schedules,
            actionsMapping: {
                resourceID: 'classroomID',
                name: 'subject',
                teacher: 'teacherName',
                filled: 'filledCapacity'
            }
        }

        $scope.onActionClicked = function (action) {
            if (!tenantSettingSvc.settings.disableClientCalendar) {
                eventDetailDlg.$scope.eventModal = {
                    action: angular.copy(action),
                    currentStudent: currentStudent
                };
                eventDetailDlg.$scope.onSaved = function () {
                    loadSemesterScheduleWithLastValues();
                };
                eventDetailDlg.$promise.then(function () {
                    eventDetailDlg.show();
                });
            }
        }

        $scope.onDateChanged = function (startDate, endDate) {
            if (Date.prototype.isValidDate(startDate) && Date.prototype.isValidDate(endDate)) {
                if (currentStudent) {
                    loadSemesterSchedule(currentSemester.id, startDate, endDate, currentStudent.compensationGroupID, currentStudent.userID);
                } else {
                    loadSemesterSchedule(currentSemester.id, startDate, endDate, null, currentUser.userID);
                }
            }
        }

        $scope.onStudentChanged = function (student) {
            currentStudent = student;
            loadSemesterScheduleWithLastValues();
        }

        function loadSemesterScheduleWithLastValues() {
            if (currentStudent) {
                loadSemesterSchedule(currentSemester.id, lastStartDate, lastEndDate, currentStudent.compensationGroupID, currentStudent.userID);
            } else {
                loadSemesterSchedule(currentSemester.id, lastStartDate, lastEndDate, null, currentUser.userID);
            }
        }

        function loadSemesterSchedule(semesterID, startDate, endDate, compensationGroupID, userID) {
            if (!Date.prototype.isValidDate(startDate) || !Date.prototype.isValidDate(endDate)) {
                return;
            }

            lastStartDate = startDate;
            lastEndDate = endDate;

            $scope.isBusy = true;

            clientSchedulerSvc.getAllForSemesterAsync(
                semesterID,
                compensationGroupID,
                userID,
                startDate,
                endDate)
            .$promise.then(function (data) {
                schedules.length = 0;
                schedules.push.apply(schedules, data);
                $scope.isBusy = false;
            }, function () {
                $scope.isBusy = false;
            });
        }

        $scope.$on('semesterchanged', function (event, tabIndex, semester) {
            if (thisTabIndex === tabIndex) {
                currentSemester = semester;
                $scope.semesterID = semester.id;
                loadSemesterSchedule(semester.id, lastStartDate, lastEndDate);
            }
        });

        var eventDetailDlg = $modal({
            templateUrl: 'schedule/event-detail-dialog.html',
            show: false,
            backdrop: true,
            scope: $scope.$new()
        });
    }
]);